export enum ScreenType {
  MOBILE = 1,
  TABLET,
  PC = 3,
}
